import { render, staticRenderFns } from "./float-shoucang.vue?vue&type=template&id=6f3a5088&"
import script from "./float-shoucang.vue?vue&type=script&lang=js&"
export * from "./float-shoucang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports